import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  style: {"background-color":"#ffffff"},
  class: "w-100 h-100"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "perUser" }, "Please select the permissions of systems below the user is going to use.", -1 /* HOISTED */)
const _hoisted_4 = { class: "user-right-div" }
const _hoisted_5 = {
  id: "usermydiv",
  class: "user-main-div"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div style=\"width:calc(100% - 16px);\"><table id=\"tblPermissinDetailInfo\"><thead><tr><th style=\"width:30%;\">Main</th><th style=\"width:30%;\">Sub</th><th style=\"width:5%;\"></th><th style=\"width:35%;\">Status</th></tr></thead></table></div>", 1)
const _hoisted_7 = {
  key: 0,
  style: {"text-align":"center","height":"calc(96% - 200px)"}
}
const _hoisted_8 = {
  id: "usertblbodydiv",
  style: {"overflow":"auto","height":"75%"}
}
const _hoisted_9 = { id: "tblPermissinDetailInfo" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { style: {"width":"30%","text-align":"left"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%","text-align":"left"} }, " ", -1 /* HOISTED */)
const _hoisted_13 = {
  class: "chkBox",
  style: {"width":"5%"}
}
const _hoisted_14 = ["id", "onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"35%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { style: {"width":"30%","text-align":"left"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30px","text-align":"left"} }, " ", -1 /* HOISTED */)
const _hoisted_19 = {
  class: "chkBox",
  style: {"width":"5%"}
}
const _hoisted_20 = ["id", "name", "onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"35%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%","text-align":"left"} }, " ", -1 /* HOISTED */)
const _hoisted_23 = { style: {"width":"30%","text-align":"left"} }
const _hoisted_24 = {
  class: "chkBox",
  style: {"width":"5%"}
}
const _hoisted_25 = ["id", "name", "disabled", "onClick"]
const _hoisted_26 = { style: {"width":"35%","height":"30.5px"} }
const _hoisted_27 = { class: "user-button-div" }
const _hoisted_28 = { class: "backuser-button-div" }
const _hoisted_29 = { class: "edituser-button-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["UserNavigation"], { menuTile: $setup.titleUser }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        ($setup.permissionDetail.length == 0 && $setup.getData)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_7, " No data "))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.permissionDetail, (item, index) => {
              return (_openBlock(), _createElementBlock("tbody", {
                id: "usertbltbody",
                key: index
              }, [
                (
                  item.mainMenuCode != '' &&
                  ((index == 0 &&
                    item.mainTitleName ==
                      $setup.permissionDetail[index + 1].mainTitleName) ||
                    (index != 0 &&
                      item.mainTitleName !=
                        $setup.permissionDetail[index - 1].mainTitleName))
                )
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                      _createElementVNode("td", _hoisted_11, _toDisplayString(item.mainTitleName), 1 /* TEXT */),
                      _hoisted_12,
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          id: 'chkHeader' + item.mainTitleCode,
                          style: {"visibility":"hidden"},
                          onClick: ($event: any) => ($setup.chkHeaderChange(item.mainTitleCode, index))
                        }, null, 8 /* PROPS */, _hoisted_14)
                      ]),
                      _hoisted_15
                    ]))
                  : _createCommentVNode("v-if", true),
                (item.mainMenuCode == '')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.mainTitleName), 1 /* TEXT */),
                      _hoisted_18,
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk' + item.mainMenuCode,
                          name: 'chk' + item.mainTitleCode,
                          onClick: ($event: any) => ($setup.chkHeaderChange(item.mainTitleCode, index))
                        }, null, 8 /* PROPS */, _hoisted_20)
                      ]),
                      _hoisted_21
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createCommentVNode(" <template v-if=\"item.data.length != 1\"> "),
                      _createElementVNode("tr", null, [
                        _hoisted_22,
                        _createElementVNode("td", _hoisted_23, _toDisplayString(item.mainMenuName), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_24, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            id: 'chk' + item.mainMenuCode,
                            name: 'chk' + item.mainTitleCode,
                            disabled: $setup.disabledCheck(item),
                            onClick: ($event: any) => ($setup.chkChange(item.mainTitleCode, _ctx.subTitleIndex))
                          }, null, 8 /* PROPS */, _hoisted_25)
                        ]),
                        _createElementVNode("td", _hoisted_26, _toDisplayString($setup.statusPermisList[index]), 1 /* TEXT */)
                      ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                _createCommentVNode(" </template> ")
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "button-back",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.backUserInfo()))
            }, "Back")
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              class: "button-apply",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateUserPermission()))
            }, " Update ")
          ])
        ])
      ])
    ])
  ]))
}